<template>
<div class='vx-col w-full mt-4'>
    <transition name="fade">
        <vx-card>
            <div class="sombra1" v-for="(item,index) in datos" :key="index">
                <a :href="`${item.url}`" target="_blank">
                    <img :src="require(`@/assets/images/plataformas/${item.imagen}`)" />
                </a>
            </div>

        </vx-card>

    </transition>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            datos: [{
                    id: 0,
                    imagen: 'idukay.jpg',
                    url: 'https://idukay.net/#/login'
                },
                {
                    id: 1,
                    imagen: 'runachay.jpg',
                    url: 'https://runachay.runacode.com/public/'
                },
                {
                    id: 2,
                    imagen: 'phet.jpg',
                    url: 'https://phet.colorado.edu/es/simulations/filter?type=html'
                },
                {
                    id: 3,
                    imagen: 'arbolabc.jpg',
                    url: 'https://arbolabc.com/'
                },
                {
                    id: 4,
                    imagen: 'cokitos.jpg',
                    url: 'https://www.cokitos.com/'
                },
                {
                    id: 5,
                    imagen: 'plazasesamo.jpg',
                    url: 'https://www.plazasesamo.com/'
                },
                {
                    id: 6,
                    imagen: 'geogebra.jpg',
                    url: 'https://www.geogebra.org/math/operations'
                },
            ]
        };
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style scoped>
.sombra1 {
    box-shadow: 5px 5px rgba(95, 95, 95, 0.2);
    margin: 10px;
    display: inline-table;
    transform: scale(1);
    transition: 0.5s;
}

.sombra1:hover {
    transform: scale(1.05);
    transition: 0.5s;
    cursor: pointer;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
}
</style>
